import styled from 'styled-components'
import { WHITE } from '../../utils/colors'

export const Container = styled.div`
  display: inline-block;
  position: relative;
  bottom: -3px;
  margin-left: 13px;

  .information_popup_content_info {
    display: none;
    position: absolute;
    background: ${WHITE};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 345px;
    padding: 20px 18px;
    font-family: 'Segoe UI', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    bottom: 45px;
    left: -16px;
    color: #818181;
  }

  .arrow_down {
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${WHITE};
    bottom: -9px;
  }


  &:hover {
    .information_popup_content_info {
      display: block;
    }
  }
`
